import React from "react";
import Paper from "@material-ui/core/Paper";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import ProjectService from "../../services/projects";

class ProjectList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false  ,showInactive:false};
  }

  update = (ev) => {
    this.setState({showInactive: ev.target.checked})
 }

  render() {
    let items = this.props.items.map(item => {
      if(this.state.showInactive===true && item.inactive===true){
        return (
          <ListItem
            key={item._id}
            onClick={e => {
              this.props.handleClick(item);
            }}
          >
            <ListItemText primary={item.projectnumber + ' - ' + item.name} secondary={(item.client?item.client.name:'') + ', ' + ProjectService.getProjectType(item.type)} />
       </ListItem>
        );
      }else if (this.state.showInactive===false && item.inactive!==true){
        return (
          <ListItem
            key={item._id}
            onClick={e => {
              this.props.handleClick(item);
            }}
          >
            <ListItemText primary={item.projectnumber + ' - ' + item.name} secondary={(item.client?item.client.name:'') + ', ' + ProjectService.getProjectType(item.type)} />
        </ListItem>
        );
      }
    });

    return (
      <div>
        <Paper>
        <FormControlLabel
              control={
                <Checkbox
                  id="inactive"
                  checked={this.state.showInactive === true}
                  onChange={this.update}
                />}
              label="Toon inactief"
              style={{paddingLeft:'9px'}}
            />
          <List>{items}</List>
        </Paper>
      </div>
    );
  }
}
export default ProjectList;
